export type Buckets<TOutcome> = {
  _: number | TOutcome;
} & Record<number, number | TOutcome>;

export const createBucket = <TOutcome>(buckets: Buckets<TOutcome>) => {
  return {
    calculate: (value: number) => {
      const thresholds = Object.keys(buckets)
        .filter((key) => key !== '_')
        .map((key) => parseInt(key, 10))
        .sort((a, b) => a - b);

      const lastValue = buckets[`${thresholds[thresholds.length - 1]}`];
      if (value < thresholds[0]) return buckets._;
      if (value >= thresholds[thresholds.length - 1]) {
        return lastValue;
      }

      for (const threshold of thresholds) {
        if (value < threshold) {
          return buckets[`${threshold}`];
        }
      }
      return lastValue;
    },
  };
};
